import * as actionTypes from './actionTypes'
import { notificationService } from '../../service'
import { errorHelper } from '../../common/helpers'
import { constants } from '../../common/constants'

export function getNotifications() {
    return async (dispatch) => {
        try {
            dispatch({ type: actionTypes.FETCH_NOTIFICATIONS })

            const response = await notificationService.getAll()
            const data = response.data

            if (data.message) {
                dispatch({
                    type: actionTypes.FETCH_NOTIFICATIONS_FAILURE,
                    payload: { error: data.message }
                })

                return
            }

            dispatch({
                type: actionTypes.FETCH_NOTIFICATIONS_SUCCESS,
                payload: {
                    notifications: data.data,
                    total: data.quantity
                }
            })
        } catch (error) {
            errorHelper.handle(error, dispatch, actionTypes.FETCH_NOTIFICATIONS_FAILURE)
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/notification/actions.js